/* tuto chartJS : https://alligator.io/angular/chartjs-ng2-charts/ */

import { _fixedSizeVirtualScrollStrategyFactory } from '@angular/cdk/scrolling';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Colors } from '../../main/Models/colors';

@Component({
  selector: 'app-synthesis-piechart',
  templateUrl: './t_piechart.component.html',
  styleUrls: ['./piechart.component.less']
})
export class PiechartComponent implements OnInit {
  
  @Input('notes') notes: number[];
  showChart = false;

  theme = {
    color: Colors.colors
  };

  options = {
    title: {
      text: 'Répartition des établissements',
      subtext: 'par catégorie d\'enjeux sécuritaires',
      x: 'center'
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    /*legend: {
      x: 'center',
      y: 'top',
      data: [
        'critiques',
        'significatifs',
        'normaux',
        'mineurs'
      ]
    },*/
    calculable: true,
    series: [
      {
        name: 'area',
        type: 'pie',
        radius: [0, 80],
        //roseType: 'area',
        data: [
          { value: 0, name: 'critiques' },
          { value: 0, name: 'significatifs' },
          { value: 0, name: 'normaux' },
          { value: 0, name: 'mineurs' },
        ]
      }
    ]
  }


  @Output() changeTriggered: EventEmitter<string> = new EventEmitter();
  currentLabel: string = null;
  currentLabelColor: string = null;

  constructor() { }

  ngOnInit(): void { this.calculateData(); }

  calculateData()
  {
    this.showChart = false;
    if(this.currentLabel!=null) return;
    this.options.series[0].data = [
      { value: 0, name: 'critiques' },
      { value: 0, name: 'significatifs' },
      { value: 0, name: 'normaux' },
      { value: 0, name: 'mineurs' },
    ];

    this.notes.forEach((note) => {
      const cat = this.getCat(note);
      this.options.series[0].data[cat].value++;
    });

    this.theme.color = Colors.colors.filter((c,i) => { 
      return this.options.series[0].data[i].value!=0; 
    });
    this.options.series[0].data = this.options.series[0].data.filter(d=>{ return d.value!=0; } );
    
    setTimeout(()=>{
      this.showChart = (this.options.series[0].data.length > 0);
    },0);
  }


  private getCat(note): number
  {
    if (note < 6) { return 0; }// 'Alarmant' -> critiques;
    else if (note <= 10) { return 1; }// 'Préoccupant' -> significatifs;
    else if (note <= 14) { return 2; }// 'Important' -> normaux;
    else { return 3; }// 'Positif' -> mineurs;
  }

  chartClick($event): void
  {
    const label = $event ? $event.name : null;
    if (this.currentLabel === label) { this.currentLabel = null; }
    else { this.currentLabel = label; }

    //this.showChart = (this.currentLabel==null);
    if(this.currentLabel!=null) {
      this.currentLabelColor = Colors.colors[this.options.series[0].data.findIndex(d=>d.name==this.currentLabel)]
    }

    this.changeTriggered.emit(this.currentLabel);
  }

}
